import IeltsFeatureList from './template';
export default IeltsFeatureList;
